import React from "react";
import { Card, CardBody, Col, Progress } from "reactstrap";

import FigureRow from "./Figures";
import { ActivityReportData } from "./types";

/**
 * Two measures that deliberately ignore the selected date range: adoption is
 * all-time by definition, and stickiness is only meaningful over fixed rolling
 * windows. The agency, page and user filters still apply to both.
 */
const AdoptionAndStickiness = ({
  data,
}: {
  data: ActivityReportData | null;
}) => {
  const adoption = data?.adoption;
  const stickiness = data?.stickiness;

  return (
    <Col xxl={4}>
      <Card className="card-height-100">
        <CardBody>
          <div className="d-flex align-items-center mb-2">
            <h5 className="card-title mb-0 flex-grow-1">Adoption</h5>
            <span className="badge bg-primary-subtle text-ink-primary fs-12">
              {adoption?.adoptionRate || 0}% have used CIMS
            </span>
          </div>
          <p className="text-ink-muted fs-13">
            Registered accounts that have opened at least one page, ever. The
            date range doesn&apos;t change these figures.
          </p>
          <Progress
            value={adoption?.adoptionRate || 0}
            color="primary"
            className="mb-3"
            style={{ height: "8px" }}
          />
          <div className="mb-4">
            <FigureRow
              size="sm"
              figures={[
                { label: "Registered", value: adoption?.registeredUsers || 0 },
                {
                  label: "Have used CIMS",
                  value: adoption?.everActiveUsers || 0,
                },
                {
                  label: "Never signed in",
                  value: adoption?.neverActiveUsers || 0,
                },
              ]}
            />
          </div>

          <div className="d-flex align-items-center mb-2">
            <h5 className="card-title mb-0 flex-grow-1">Return visits</h5>
            <span className="badge bg-info-subtle text-ink-info fs-12">
              {stickiness?.dauOverMau || 0}% back today
            </span>
          </div>
          <p className="text-ink-muted fs-13">
            Of the people who used CIMS in the last 30 days, the share who have
            used it today. Also unaffected by the date range.
          </p>
          <Progress
            value={stickiness?.dauOverMau || 0}
            color="primary"
            className="mb-3"
            style={{ height: "8px" }}
          />
          <FigureRow
            size="sm"
            figures={[
              { label: "Today", value: stickiness?.dau || 0 },
              { label: "Last 7 days", value: stickiness?.wau || 0 },
              { label: "Last 30 days", value: stickiness?.mau || 0 },
            ]}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default AdoptionAndStickiness;
